import { io } from 'socket.io-client'
import { useSelector } from 'react-redux'
import config from 'config/app.config'
import NAMESPACES from 'socket-resources/namespaces/index'
import { RANKING } from 'socket-resources/event-constants/ranking/index'

const useRankingSocketNameSpace = () => {
  const { loginData } = useSelector(state => state.auth) // Fetch the latest token

  const listenRankingUpdateEvent = (cb) => {
    const rankingInstance = io(`${config.SOCKET_URL}${NAMESPACES.RANKING}`, {
      auth: {
        authorization: `Bearer ${loginData?.accessToken}`
      }
    })

    rankingInstance.on('connect', () => {
      // console.log('Connected to RANKING namespace with new token')
    })

    rankingInstance.on('disconnect', () => {
      // console.log('Socket disconnected from RANKING namespace')
    })
    if (cb) {
      rankingInstance.on(RANKING, cb)
    }
    return () => {
      rankingInstance?.off(RANKING, cb)
      rankingInstance?.disconnect()
    }
  }

  return { listenRankingUpdateEvent }
}

export default useRankingSocketNameSpace
